/**
 * Read a single query parameter from a search string without treating "+" as space.
 * URLSearchParams follows x-www-form-urlencoded rules where "+" means space, which breaks
 * base64-like tokens that contain literal "+".
 *
 * @param {string} search - e.g. location.search ("?a=1&b=2") or "a=1&b=2"
 * @param {string} paramName - parameter name
 * @returns {string} decoded value (decodeURIComponent), empty if missing
 */
export function getQueryParamRaw(search, paramName) {
  if (!paramName) return "";
  const q = search && search.startsWith("?") ? search : `?${search || ""}`;
  const escaped = paramName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const re = new RegExp(`[?&]${escaped}=([^&]*)`);
  const m = re.exec(q);
  if (!m) return "";
  const raw = m[1];
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}
